import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=4e68cbca&scoped=true&"
import script from "./ExpandableText.vue?vue&type=script&lang=js&"
export * from "./ExpandableText.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableText.vue?vue&type=style&index=0&id=4e68cbca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e68cbca",
  null
  
)

export default component.exports